import { siteConfiguration } from 'siteConfig';
import { NavLink } from 'react-router-dom';
import './style.css';
import { useLanguageContext } from 'context/LanguageProvider';

const Navbar = ({ closeNavBar, whiteColor, scrolledStyling }) => {
	const { navigationLinks } = siteConfiguration;
	const { currentLanguage } = useLanguageContext();
	return (
		<nav className="nav-container">
			<ul className="navlinks-container">
				{navigationLinks.map((navigationLink, id) => {
					if (!navigationLink.isActive) return null;

					return navigationLink.isURL ? (
						<li key={`nav-${id}`}>
							<a
								href={navigationLink.url}
								onClick={closeNavBar}
								className={`navlink ${whiteColor && !scrolledStyling ? 'white-active' : ''}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								{navigationLink.text[currentLanguage]}
							</a>
						</li>
					) : (
						<li key={`nav-${id}`}>
							<NavLink
								to={navigationLink.route}
								onClick={closeNavBar}
								className={({ isActive: isNavActive }) =>
									isNavActive
										? 'navlink-active'
										: `navlink ${whiteColor && !scrolledStyling ? 'white-active' : ''}`
								}
							>
								{navigationLink.text[currentLanguage]}
							</NavLink>
						</li>
					);
				})}
			</ul>
		</nav>
	);
};

export default Navbar;
